import { render, staticRenderFns } from "./dispute_list.vue?vue&type=template&id=75220044"
import script from "./dispute_list.vue?vue&type=script&lang=js"
export * from "./dispute_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports